import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IRegion } from '../../models/region.model';
import { EntityService, IEntityListResult } from '../entity.service';

@Injectable()
export class RegionApiService extends EntityService<IRegion> {
	public entityName = 'regions';

	constructor(http: HttpClient) {
		super(http);
	}

	public suggest(region: Partial<IRegion>): Observable<IRegion[]> {
		return this.post<IEntityListResult<IRegion>, Partial<IRegion>>([this.entityName, 'suggest'], region).pipe(map(result => result.data));
	}
}
